import { createContext, useContext, type Context, type Provider } from 'react';

export type RovoNudgePlacementConfig = {
	/** Discard previously delivered messages when the subscription fails. */
	clearOnSubscriptionError?: boolean;
	/** Restart the subscription when its tenant or pathname changes. */
	resetOnNavigation?: boolean;
	/** Register messages separately from the host's default nudge queue. */
	nudgeSource?: string;
};

const PlacementConfigContext: Context<RovoNudgePlacementConfig> =
	createContext<RovoNudgePlacementConfig>({});

export const RovoNudgePlacementConfigProvider: Provider<RovoNudgePlacementConfig> =
	PlacementConfigContext.Provider;

export const useRovoNudgePlacementConfig = (): RovoNudgePlacementConfig =>
	useContext(PlacementConfigContext);
